import Component from '../abstracts/Component';
import Cookies from 'js-cookie';
import NewsletterLogic from '../logics/NewsletterLogic';

export default class NewsletterComponent extends Component {

  get SELECTORS() {
    return {
      newsletterFormWrapper: '.news__form__wrapper',
      form: '.js-newsletter-form',
      jsContent: '.js-modal-form-contents',
      submitButton: '.js-nl-submission',
      privacyCheckbox: '#privacy-news-footer',
      body: 'body',
      newsletterBox: '.w-newsletter',
      inputEmail: 'input[type=email]'
    };
  }

  constructor(compEl) {
    super(compEl);
    // elements
    this.submitButton = this.$component.querySelector(this.SELECTORS.submitButton);
    this.privacyCheckbox = this.$component.querySelector(this.SELECTORS.privacyCheckbox);
    this.body = this.$component.querySelector(this.SELECTORS.body);
    this.newsletterBox = this.$component.querySelector(this.SELECTORS.newsletterBox);
  }

  // istantiate properties
  initProperties() {
    this.modalkey = $(document.body).data('nlKey') ? $(document.body).data('nlKey') : 'default_modal';
    this.hideCookieKey = 'nl_' + this.modalkey + '_hide';
    this.startTime = $(document.body).data('nlStartTime'); //new Date().setTime();
    this.endTime = $(document.body).data('nlEndTime'); //new Date().setTime();
    this.templateName = $(document.body).data('nlTemplate');
    this.link = $(document.body).data('nlLink') ? $(document.body).data('nlLink') : '/modals/newsletter';
  }

 // enable form submit button
  enableSubmitBtn() {
    if ( this.privacyCheckbox.checked === true ) {
       this.submitButton.disabled = false;
    } else {
      this.submitButton.disabled = true;
    }
  }



  // main events function
  bindEvents() {

    // enable submit
    this.privacyCheckbox.addEventListener('click', e => {
      this.enableSubmitBtn();
    });

    // DOM READY
    $(document).ready(() =>{
      // check form
      this.enableSubmitBtn();
    });

    //
    this.$on('submit.newsletter', this.NewsletterLogic.subscribeToNewsletter, this.SELECTORS.newsletterBox, this.SELECTORS.form, this);
  }

  // main render function
  render() {
    this.log('Rendering...');
    // loading logics
    this.NewsletterLogic = new NewsletterLogic();
    // init vars
    this.initProperties();
    // go events
    this.bindEvents();
  }
}
